// @flow

import ophan from 'ophan/ng';

const tracking = (trackingObj: { widgetId?: string }): void => {
    ophan.record({
        outbrain: trackingObj,
    });
};

export { tracking };



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/commercial/modules/third-party-tags/outbrain-tracking.js